var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCloseOctagonOutline = function SvgCloseOctagonOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    fillRule: "nonzero",
    d: "M4.684 0 0 4.684v6.632L4.684 16h6.632C12.889 14.436 16 11.316 16 11.316V4.684L11.316 0M5.054.889h5.892l4.165 4.165v5.892l-4.165 4.165H5.054L.889 10.946V5.054m4.551-.867L4.187 5.44 6.747 8l-2.56 2.56 1.253 1.253L8 9.253l2.56 2.56 1.253-1.253L9.253 8l2.56-2.56-1.253-1.253L8 6.747"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseOctagonOutline);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;